import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { AI_ASSIST, type AiAssistStateType } from "./types";

const aiAssistInitialState: AiAssistStateType = {
	writes: {},
};

export const aiAssistSlice = createSlice({
	name: AI_ASSIST,
	initialState: aiAssistInitialState,
	reducers: {
		receiveAiWrites: (aiAssist, { payload: playlistGraphicIds }: PayloadAction<string[]>) => {
			playlistGraphicIds.forEach((id) => {
				aiAssist.writes[id] = (aiAssist.writes[id] ?? 0) + 1;
			});
		},
	},
});

const actions = aiAssistSlice.actions;
const aiAssistReducer = aiAssistSlice.reducer;

export { actions, aiAssistReducer };
